import Papa from 'papaparse'

export function stringOrNumberSort(a: string, b: string) {
  return String(a).localeCompare(String(b), undefined, {
    numeric: !!Number(a) && !!Number(b),
  })
}
export function byStringFieldSort(...fields: string[]) {
  return (a: any, b: any) => {
    return fields.reduce((acc, field) => {
      if (acc !== 0) return acc
      const fieldA = a[field]
      const fieldB = b[field]
      return stringOrNumberSort(fieldA, fieldB)
    }, 0)
  }
}

export function toCamel(s: string) {
  return s.replace(/([-_ ][a-z])/gi, ($1) => {
    return $1.toUpperCase().replaceAll(/[-_ ]/g, '')
  })
}

export function camelToTitle(str: string) {
  return (
    str
      // Insert a space before all caps
      .replace(/([A-Z])/g, ' $1')
      // Capitalize the first letter
      .replace(/^./, (str) => str.toUpperCase())
      // Trim in case of leading spaces
      .trim()
  )
}

function isArray(a: any) {
  return Array.isArray(a)
}

function isObject(o: any) {
  return o === Object(o) && !isArray(o) && typeof o !== 'function'
}

export function deepMapKeysToCamel<T>(o: any): T {
  if (isObject(o)) {
    const n: { [key: string]: any } = {}

    Object.keys(o).forEach((k) => {
      n[toCamel(k)] = deepMapKeysToCamel(o[k])
    })

    return n as T
  } else if (isArray(o)) {
    return o.map((i: any) => {
      return deepMapKeysToCamel(i)
    }) as T
  }

  return o
}

export async function parseCsvDataWithHeaders<T>(
  raw: string,
  { startingRow }: { startingRow?: number } = {},
) {
  const toParse = startingRow
    ? raw.split('\n').slice(startingRow).join('\n')
    : raw
  const contentList = await parseCsvDataAsList(toParse)
  return parseCsvDataWithHeaderRow<T>(contentList)
}

export async function parseCsvDataAsList(raw: string) {
  return new Promise<string[][]>((resolve) => {
    Papa.parse<string[]>(raw.trim(), {
      complete: ({ data }) => {
        resolve(data)
      },
    })
  })
}

export async function parseCsvData<T>(
  raw: string,
  options: { startingRow?: number } = {},
): Promise<T[]> {
  const { data } = await parseCsvDataWithHeaders<T>(raw, options)
  return data
}

export function csvDataMap<T>(
  headers: string[],
  lines: (string | number | undefined)[][],
): T[] {
  return lines.map<T>((lineData) => {
    return headers.reduce<T>((acc, header, index) => {
      return {
        ...acc,
        [header]: lineData[index],
      }
    }, {} as T)
  })
}

export function parseCsvDataWithHeaderRow<T = Record<string, string>>(
  lines: string[][],
) {
  const headers = lines
    .splice(0, 1)[0]
    .map((s) => s.toLowerCase())
    .map(toCamel)
  const data = csvDataMap<T>(headers, lines)
  return { data, headers }
}

export function openTab(path: string) {
  window.open(path)?.focus()
}
